import { render, staticRenderFns } from "./CertificatePanel.vue?vue&type=template&id=45637a9a"
import script from "./CertificatePanel.vue?vue&type=script&lang=js"
export * from "./CertificatePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports